var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"label"},[(_vm.error)?_c('div',[_c('div',{staticClass:"input-error",domProps:{"innerHTML":_vm._s(_vm.removeSentenceEndingChar()+ '.')}})]):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(_vm._s(_vm.required ? '*' : '')+" "),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }